<template>
    <div class="job-machinery-count">
        <div
            v-for="item of data"
            :key="item.key"
            :style="`backgroundImage: url(${item.image})`"
            class="count__item"
        >
            <div class="count__item--value">{{ item.value }}</div>
            <div class="count__item--name">
                <span>{{ item.name }}</span>
                <span>({{ item.unit }})</span>
            </div>
        </div>
    </div>
</template>
<script>
import * as largeScreenAPI from '@/api/large-screen'
import { handleData } from '@/utils/index'

const nameList = ['机耕', '机插', '机防', '机收', '机烘']

export default {
    data() {
        return {
            id: this.$route.query.id,
            data: []
        }
    },
    methods: {
        async getJobMachineryCount() {
            const { id } = this

            const response = await largeScreenAPI.getJobMachineryCount(id)
            if (response.data.length) {
                this.data = handleData(response.data)
                this.data.forEach((item, index) => {
                    item.name = nameList[index]
                    item.unit = '台'
                    item.image = require(`../../../assets/images/${
                        item.key.split('Sum')[0]
                    }.png`)
                })
            }
        }
    },
    mounted() {
        this.getJobMachineryCount()
    }
}
</script>
<style lang="scss" scoped>
.job-machinery-count {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 38px;
    background-image: url('../../../assets/images/job-count-bg.png');
    background-size: calc(100% - 50px) 87px;
    background-repeat: no-repeat;
    background-position: 25px 156px;
    .count__item {
        width: 115px;
        height: 231px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-top: 22px;
        &:nth-child(2n-1) {
            .count__item--value {
                color: #25fcfa;
            }
        }
        &:nth-child(2n) {
            .count__item--value {
                color: #f9b236;
            }
        }
        &--value {
            text-align: center;
            font-size: 26px;
            font-weight: 600;
            margin-bottom: 8px;
        }
        &--name {
            text-align: center;
            span {
                font-size: 18px;
                &:first-child {
                    color: #fff;
                    margin-right: 5px;
                }
                &:last-child {
                    color: #a3a3a3;
                }
            }
        }
    }
}
</style>
